import {Injectable, signal} from '@angular/core';
import {RecordData} from "../types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class RecordCalendarIdsStateService {
  private _recordCalendarIdsState = signal<Array<number>>([]);
  public recordCalendarIdsState = this._recordCalendarIdsState.asReadonly();

  public setRecordCalendarIdsState(recordData: Array<RecordData>): void {
    const ids = recordData.map(i => Number(i.id))
    this._recordCalendarIdsState.set(ids)
  }

  public resetRecordCalendarIdsState(): void {
    this._recordCalendarIdsState.set([]);
  }
}
